import { EThemes } from '@/lib/contentstack-sdk/types';
import { OrMiniCtaBlockB } from './or-mini-cta-block-b';
import { parseGlobalLinkFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { IMiniCtaBlockBPropsCS } from './or-mini-cta-block-b.types';

export const OrMiniCtaBlockBCS = ({ block }: IMiniCtaBlockBPropsCS) => {
  const {
    cta,
    description,
    icon: { icon },
    theme: { theme },
    top_spacing,
    bottom_spacing,
  } = block;
  const ctaProps = parseGlobalLinkFromCMS(cta, 'or-mini-cta-block');

  return (
    <OrMiniCtaBlockB
      cta={ctaProps}
      theme={EThemes[theme]}
      icon={icon || null}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
    >
      <RenderRichText body={description} />
    </OrMiniCtaBlockB>
  );
};
